import { BLOGS_PART_1 } from "./blogs-part1";
import { BLOGS_PART_2 } from "./blogs-part2";

// Combined corpus — 10 SEO-optimised, deeply-structured articles for OneLoan.in
export const BLOGS = [...BLOGS_PART_1, ...BLOGS_PART_2];

export const BLOG_CATEGORIES = [...new Set(BLOGS.map((b) => b.category))];

export const findBlog = (slug) => BLOGS.find((b) => b.slug === slug);
export const relatedBlogs = (slug, n = 3) =>
  BLOGS.filter((b) => b.slug !== slug).slice(0, n);
